export default __webpack_public_path__ + "static/media/aquarium-05.5bfc73b2.png";